export class Feature {
  Type: string;

  public constructor(init?: Partial<Feature>) {
    Object.assign(this, init);
  }
}
